import Vue from 'vue'
import axios from 'axios';
import App from './App.vue'
import router from './router'
import store from './store'

// 完整引入 ElementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// 完整引入 Vant
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.config.productionTip = false;

// 完整注册 ElementUI
Vue.use(ElementUI);

// 完整注册 Vant
Vue.use(Vant);

Vue.prototype.$http = axios;

// 添加全局错误处理
Vue.config.errorHandler = function (err, vm, info) {
  console.error(`Error: ${err.toString()}\nInfo: ${info}`);
  Vue.prototype.$message.error('发生错误，请稍后再试');
};

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
